<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body :class="{ open: visibleBody }">
          <b-card-header
            header="Información Signos Vitales"
            :class="{ collapsed: !visibleBody }"
            :aria-expanded="visibleBody ? 'true' : 'false'"
            role="tab"
            data-toggle="collapse"
            @click="onVisibleBody(!visibleBody)"
            style="background-color: #0080C9; color: white; font: 75px; padding: 15px; cursor: pointer;"
          >
            <span class="lead collapse-title">
              <strong>Información Signos Vitales</strong>
            </span>

            <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
          </b-card-header>

          <b-collapse v-model="visibleBody" role="tabpanel">
            <b-card-body style="padding: 1.5rem">
              
              <div 
                class="d-flex justify-content-end mb-1" 
              >
                <b-button 
                  v-if="!noCopyBytton"
                  @click="copyAS400()" 
                  variant="info" 
                >
                  Copy AS400
                </b-button>

                <b-button class="ml-1" variant="warning" @click="viewEvolucion()">
                  <i class="fas fa-signal"/>
                </b-button>
              </div>

              <span v-if="!noCitaActual">
                <h5> <b> Cita Actual: </b></h5>


                <b-alert show class="p-1" v-if="signosActuales">
                  <div class="row align-items-center">

                    <div class="col-10 mb-1">Fecha: <span class="text-dark">{{ signosActuales[0].fecha }}</span></div>
                    <div class="col-2 mb-1">

                      <!-- <b-button 
                        v-if="!noCopyBytton"
                        @click="copyAS400()" 
                        variant="info"
                        style="padding: 7px; margin-right: px;"
                        size="sm"
                      >
                        Copy AS400
                      </b-button> -->

                      <b-button 
                        variant="info" 
                        size="sm" 
                        @click="viewSignosDetails(signosActuales[0].tokenSignos)"
                        style="padding: 7px;"
                      >
                        <font-awesome-icon icon="magnifying-glass" style="color: white"/>
                      </b-button>
                    </div>
                    <div class="col-6">Peso <small>(kg)</small>: <span class="text-dark">{{ signosActuales[0].signosVitales.peso }}</span></div>
                    <div class="col-6">Talla <small>(cm)</small>: <span class="text-dark">{{ signosActuales[0].signosVitales.talla }}</span></div>
                    <div class="col-6">IMC : <span class="text-dark">{{ signosActuales[0].signosVitales.imc }}</span></div>
                    <div class="col-6">Temp <small>(°C)</small>: <span class="text-dark">{{ signosActuales[0].signosVitales.temperatura }}</span></div>

                    <div class="col-6 mt-1">Frec resp <small>(rmp)</small>: <span class="text-dark">{{ signosActuales[0].signosVitales.freqRespiratoria }}</span></div>
                    <div class="col-6 mt-1">Sat oxig <small>(%)</small>: <span class="text-dark">{{ signosActuales[0].signosVitales.satOxigeno }}</span></div>
                    <div class="col-6">Pres arterial: <span class="text-dark">{{ signosActuales[0].signosVitales.tensionArterialSistolica }} / {{ signosActuales[0].signosVitales.tensionArterialDiastolica }}</span></div>
                    <div class="col-6">Pulso <small>(lpm)</small>: <span class="text-dark">{{ signosActuales[0].signosVitales.pulso }}</span></div>

                    <div class="col-6 mt-1">P Abdominal: <span class="text-dark">{{ signosActuales[0].perimetroAbdominal || '-' }}</span></div>
                    <div class="col-6 mt-1">P Cefalico: <span class="text-dark">{{ signosActuales[0].perimetroCefalico || '-' }}</span></div>
                  </div>

                </b-alert>
  
                <!-- <b-table 
                  :items="signosActuales" 
                  :fields="fields" 
                  bordered hover fixed responsive 
                  head-variant ="light"  
                  small 
                >
  
                  <template #cell(presionArterial)="data">
                    {{ data.item.signosVitales.tensionArterialSistolica }} / {{ data.item.signosVitales.tensionArterialDiastolica }}
                  </template>
                  
                  <template #cell(detalles)="data">
                    <div class="d-flex justify-content-center">
                      <b-button 
                        variant="info" 
                        size="sm" 
                        @click="viewSignosDetails(data.item.tokenSignos)"
                        style="padding: 7px;"
                      >
                        <font-awesome-icon icon="magnifying-glass" style="color: white"/>
                      </b-button>
                    </div>
                  </template>
                </b-table> -->
                
                <hr/>
              </span>


              <span>
                <h5 class="mt-2"> <b> Citas anteriores: </b></h5>
              
                <b-table 
                  v-if="signosAnteriores && signosAnteriores.length"
                  :items="signosAnteriores" 
                  :fields="fields" 
                  fixed responsive small bordered
                >
                  
                  <template #cell(presionArterial)="data">
                    {{ data.item.signosVitales.tensionArterialSistolica }} / {{ data.item.signosVitales.tensionArterialDiastolica }}
                  </template>
  
                  <template #cell(detalles)="data">
                    <div class="d-flex justify-content-center">
                      <b-button 
                        variant="info" 
                        size="sm" 
                        @click="viewSignosDetails(data.item.tokenSignos)"
                        style="padding: 7px;"
                      >
                        <font-awesome-icon 
                          icon="magnifying-glass" 
                          style="color: white"
                        />
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </span>

            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>


    <b-modal id="modal-chart" size="xl" hide-footer>
      <ChartSignosVitales 
        :historialSignos = "historialSignos" 
      />
    </b-modal>

    <SignoModalViewDetails
      :tokenSignos.sync="tokenSignosView"
    />

    
  </div>
</template>

<script>
import { BootstrapVue }         from 'bootstrap-vue';
import { copyText }             from '@/shared/helpers';
import { signosVitalesService } from '@/views/signosVitales/services';
import SignoModalViewDetails    from '@/views/signosVitales/SignoModalViewDetails.vue';
import ChartSignosVitales       from './ChartSignosVitales.vue';

export default {
  name: "InfoSignosVitales",

  components: {
    SignoModalViewDetails,
    ...BootstrapVue.components,
    ChartSignosVitales
  },

  props: {
    idPaciente: String,
    idCitaActual: String,

    noCopyBytton: {
      type: Boolean,
      default: false
    },

    noCitaActual: {
      type: Boolean,
      default: false
    },

    signosCita: Array,
    fechasCitas: Array,
    edadesCitas: Array,
  },

  created() {

    this.loadData();

    if (this.signosCita && this.signosCita.length > 0) {
      this.fillSignos();
    }
  },

  

  data() {
    return {

      signosActuales: null,
      signosAnteriores: null,
      historialSignos: null,
      tokenSignosView: null,

      edadCita : null,
      itemselected : null,
      dataAtencionMedica: null,
      dataSignosVitales: null,
      visibleBody: true,
      idCita: null,
      items: [],
      itemsactual : [],
      fields: [
        {
          key: "fecha",
          label: "fecha",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "presionArterial",
          label: "Pre Art",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "signosVitales.peso",
          label: "Peso Kg",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "signosVitales.imc",
          label: "IMC",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "detalles",
          label: "Ver",
          sortable: true,
          thClass: "text-center",
        }
      ]
    }
  },



  methods: {

    async loadData(){
      const responseHistorial = await signosVitalesService.getHistorialByPaciente(this.idPaciente);
      if (!responseHistorial) return;

      const citasConSignosVitales = responseHistorial.citas.filter( cita => cita.signosvitalSet.length);

      const signosMapper = citasConSignosVitales.map(cita => {

        return {
          idCita        : cita.id,
          fecha         : cita.fechaCita,
          paciente      : cita.paciente.persona,
          signosVitales : cita.signosvitalSet[0],
          tokenSignos   : cita.signosvitalSet[0].token
        }
      });

      const historialSinActual = signosMapper.filter( s => s.idCita !== this.idCitaActual);
      const citaActual         = signosMapper.find( s => s.idCita === this.idCitaActual);

      this.historialSignos  = signosMapper;
      this.signosActuales   = [citaActual];
      this.signosAnteriores = historialSinActual;

      // this.$store.commit('setCurrentSignos', this.signosActuales?.[0].signosVitales);
    },

    async viewSignosDetails(token){
      this.tokenSignosView = token;    
    },

    async viewEvolucion(){
      await this.$bvModal.show("modal-chart");
    },
    
    fillSignos() {
      this.items = []
      this.itemsactual = []
     
      let freqRespiratoria = "No disponible"
      let imc              = "No disponible"
      let peso             = "No disponible"
      let talla            = "No disponible"
      let temperatura      = "No disponible"
      let satOxigeno       = "No disponible"
      let tensionArterialDiastolica = "No disponible"
      let tensionArterialSistolica = "No disponible"
      let pulso              = "No disponible"
      let perimetroAbdominal = "No disponible"
      let perimetroCefalico  = "No disponible"
      let fechaCita          = ''

      for (let i = 0; i < this.signosCita.length; i++){ 

        if (this.signosCita[i]) {
          this.edadCita = this.edadesCitas[i]
          freqRespiratoria = this.signosCita[i].freqRespiratoria
          imc = this.signosCita[i].imc
          peso = this.signosCita[i].peso
          talla = this.signosCita[i].talla
          temperatura = this.signosCita[i].temperatura
          satOxigeno = this.signosCita[i].satOxigeno
          pulso = this.signosCita[i].pulso
          tensionArterialDiastolica = this.signosCita[i].tensionArterialDiastolica
          tensionArterialSistolica = this.signosCita[i].tensionArterialSistolica
          perimetroAbdominal = this.signosCita[i].perimetroAbdominal
          perimetroCefalico = this.signosCita[i].perimetroCefalico
          fechaCita = this.signosCita[i].fechaCita


        }
        
        if ( i === 0 ) {

          this.itemsactual.push({
            fechaCita : fechaCita,
            imc : imc,
            peso : peso,
            talla : talla,
            temperatura : temperatura,
            satOxigeno : satOxigeno,
            pulso : pulso,
            tensionArterialDiastolica : tensionArterialDiastolica,
            tensionArterialSistolica : tensionArterialSistolica,
            perimetroAbdominal : perimetroAbdominal,
            perimetroCefalico : perimetroCefalico,
            freqRespiratoria : freqRespiratoria
          })

        } else if (this.items.length < 3) {
        
          this.items.push({
            fechaCita : fechaCita,
            imc : imc,
            peso : peso,
            talla : talla,
            temperatura : temperatura,
            satOxigeno : satOxigeno,
            pulso : pulso,
            tensionArterialDiastolica : tensionArterialDiastolica,
            tensionArterialSistolica : tensionArterialSistolica,
            perimetroAbdominal : perimetroAbdominal,
            perimetroCefalico : perimetroCefalico,
            freqRespiratoria : freqRespiratoria
          })
        }
      
      }
    },

    onVisibleBody(value) {
      this.visibleBody = value;
    },

    copyAS400() {

      const { 
        temperatura, peso, imc, pulso, 
        freqRespiratoria, satOxigeno, talla,
        perimetroCefalico, perimetroAbdominal, 
        tensionArterialDiastolica, tensionArterialSistolica
      } = this.signosActuales[0].signosVitales;

      const perCefalico = perimetroCefalico === 0 ? '' : perimetroCefalico
      const perAbdominal = perimetroAbdominal === 0 ? '' : perimetroAbdominal

      const signosVitalesInfo = (temperatura ? temperatura : " " ) + "\n" 
        + tensionArterialSistolica + "/" + tensionArterialDiastolica + "\n" 
        + pulso + "\n" 
        + freqRespiratoria + "\n" 
        + peso + "\n" 
        + talla + "\n" 
        + imc + "\n" 
        + satOxigeno + "\n" 
        + perCefalico + "\n" 
        + perAbdominal;

      copyText(signosVitalesInfo)
    },
  },

  watch: {

    signosCita: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.fillSignos();
        }
      },
      deep: true,
      immediate: true
    },


    idPaciente(){
      this.loadData();
    }
  },

}
</script>
<style >
.peso-alto {
  background-color: #FF6961;
  border-radius: 8px; 
  padding: 5px; 
  color: yellow;
}
</style>
